import { useTableActionContext } from '@aibees/elephant/context';
import { useSearchSimilarityFromRoute } from '@aibees/elephant/hooks';
import { ACCORDION_IDS } from '@aibees/shared/store';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo, useMemo } from 'react';
import { ExportTemplateSelect } from '../export-dialog/components/export-templates-select';
import { noteConfig, noteConfigLookalike } from '../export-dialog/config';
import { useTemplateContext } from '../export-dialog/context/TemplateContext';
import { useExportTemplateDisabled } from '../export-dialog/hooks/use-export-template-disabled';
import { SearchTableActionDialogNotes } from '../search-table-action-dialog-notes';
import * as Styled from './styles';
import * as SX from './sx';
import type { CsvExportTemplateSettingActionBulkModalProps as Props } from './types';

const DEFAULT_TEMPLATE_NAME = 'Default Template';

export const CsvExportTemplateSettingActionBulkModal = memo(
  ({
    className,
    firstState,
    expandedAccordion,
    setExpandedAccordion,
  }: Props) => {
    const { selectedTemplate, selectedPreset } = useTemplateContext();
    const { templateDialogState, integrationConfig } = useTableActionContext();
    const isSimilarity = useSearchSimilarityFromRoute();

    const _handleClickOpen = () => {
      templateDialogState.onTrue();
      firstState.onFalse();
    };
    const _isDisabled = useExportTemplateDisabled();

    const currentNoteConfig = isSimilarity ? noteConfigLookalike : noteConfig;

    const description = useMemo(() => {
      return (
        selectedTemplate?.name || selectedPreset?.name || DEFAULT_TEMPLATE_NAME
      );
    }, [selectedTemplate, selectedPreset?.name]);

    return (
      <Styled.Wrapper
        id={ACCORDION_IDS.CSV_EXPORT}
        className={classnames(
          'CsvExportTemplateSettingActionBulkModal',
          className
        )}
        sx={SX.root}
        title="Export Template"
        leftIcon="file-csv-outline"
        description={description}
        unmountOnExit={!integrationConfig}
        expandedAccordion={expandedAccordion}
        setExpandedAccordion={setExpandedAccordion}
      >
        <Stack gap={2}>
          <ExportTemplateSelect firstState={firstState} />

          <SearchTableActionDialogNotes config={currentNoteConfig} />
        </Stack>
      </Styled.Wrapper>
    );
  }
);

CsvExportTemplateSettingActionBulkModal.displayName =
  'CsvExportTemplateSettingActionBulkModal';
